module.exports = __webpack_public_path__ + "static/media/DSC_8071.859b2d77.jpg";